import { css } from 'lit';

export const links = css`
  .grv-link {
    color: #255f82;
    text-decoration: underline;
  }

  .grv-link:visited {
    color: #255f82;
  }

  .grv-link:hover {
    color: #013d5b;
  }

  .grv-link:active {
    color: #10253f;
  }
`;
